"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.injectHttps = void 0;
var injectHttps = function (url) {
    if (['mailto:', 'tel:', 'http://', 'https://', 'data:'].every(function (d) { return typeof url === 'string' && !url.startsWith(d); })) {
        return 'https://' + url;
    }
    else {
        return url;
    }
};
exports.injectHttps = injectHttps;
